import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { constants } from "../../../utils/constants";
import { AuthService } from "src/app/services/auth.service";
import { IErrorAlert } from "src/app/interfaces/error.interface";
import { ICredentials } from "src/app/interfaces/credentials.interface";
import helpers from "src/app/utils/helpers";
import { TranslatorService } from "../../../services/translator.service";
import { AccountService } from '../../../services/account.service';

@Component({
  selector: "app-login-company",
  templateUrl: "./login-company.component.html",
  styleUrls: ["../../auth.styles.css"],
})
export class LoginCompanyComponent implements OnInit {
  constants: any = constants;
  helpers = helpers;
  docTypes: any[] = [];
  maxLengthDoc: number;
  companyForm: FormGroup;
  loading: boolean = true;
  error: IErrorAlert = null;
  countLogin: number = 0;

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    public _auth: AuthService,
    public _account: AccountService,
    public _translator: TranslatorService,
    
  ) {}

  ngOnInit() {
    this.initForm();
    this._translator.getDocTypes().subscribe(
      (docTypes: any) => {
        this.docTypes = docTypes;
        this.loading = false;
      },
      (err) => {
        this.error = err;
        this.companyForm.controls["docType"].disable();
        this.loading = false;
      })
  }
  

  onChange(event: any) {
    let control = this.companyForm.controls["docNumber"];
    this.maxLengthDoc = helpers.onChangeDocType(event, control);
  }

  login() {
    this.error = null;
    this.loading = true;
    const credentials: ICredentials = {
      ruc: this.companyForm.controls["ruc"].value,
      docType: this.companyForm.controls["docType"].value,
      docNumber: this.companyForm.controls["docNumber"].value,
      password: this.companyForm.controls["password"].value,
    };

    this._auth.login(credentials, "CLIENTE").subscribe(
      () => this._router.navigate([this._auth.user.getHomeUrl()]),
      (err: IErrorAlert) => {

        if(this.countLogin < 5 && (err.code == 500 || err.code == 400)){
          this.countLogin++;
          this.login();

        }else{
          this.countLogin = 0;
          this.error = err;
          this.loading = false;

        }
      }
    );
  }

  initForm() {
    this.companyForm = this._fb.group({
      ruc: [
        "",
        [
          Validators.required,
          Validators.pattern(constants.validations.numeric.pattern),
          Validators.minLength(11),
        ],
      ],
      docNumber: [
        { value: "", disabled: true }, 
        [
         Validators.required,
         Validators.pattern(constants.validations.numeric.pattern),
         Validators.maxLength(8),
        ],
      ],
      docType: ["", Validators.required],
      password: [
        "",
        [
          Validators.required,
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(constants.validations.numeric.pattern),
        ],
      ],
    });
    this.helpers.initFormListeners(this.companyForm);
  }

  anyAlert() {
    return (
      ((helpers.invalidControl(this.companyForm.get("ruc")) &&
        !this.companyForm.get("ruc").errors.required)) 
      ||
      this.error
    );
  }
  
  navigateTo(route: string) {
    this._account.reset();
    this._router.navigate([route]);
  }
  
}
